module.exports = __webpack_public_path__ + "images/schematic-diagram-01a668600a.png";